//Core modules
import React, {Fragment} from 'react';

//Internal modules
import SettingsContent from "./SettingsContent";

class SettingsContainer extends React.Component{

    constructor(props) {
        super(props);

        let componentNav = "";
        let selectedTab = "";
        let formname = "";
        let formid = "";
        let action = "";
        let url = window.location.href;

        if(props.match !== undefined && props.match.params.navType !== undefined){
            componentNav = props.match.params.navType
        }

        if(props.match !== undefined && props.match.params.tabName !== undefined){
            selectedTab = props.match.params.tabName;
        }

        if(props.match !== undefined && props.match.params.formname !== undefined){
            formname = props.match.params.formname;
        }

        if(props.match !== undefined && props.match.params.id !== undefined){
            formid = props.match.params.id;
        }

        if(url.includes('new')){
            action = "new";
        }else if(url.includes('edit')){
            action = "edit";
        }

        this.state={
            selectedComponent : componentNav,
            selectedTab : selectedTab,
            formid : formid,
            formname : formname,
            action : action,
        }
    }

    componentDidMount = async () => {

    }

    render () {

        let {
            selectedComponent,
            selectedTab,
            formid,
            formname,
            action,
        } = this.state;

        return (

                <Fragment>
                    <div className="setup-container">
                        <SettingsContent
                            selectedComponent={selectedComponent}
                            selectedTab={selectedTab}
                            formid={formid}
                            formname={formname}
                            action={action}
                        />
                    </div>
                </Fragment>

        )
    }
}

export default SettingsContainer;
